import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import PrivacyPolicy from './components/PrivacyPolicy';
import ContactUs from './components/ContactUs';
import RequestAccountDelete from './components/RequestAccountDelete';
import TermsOfUse from './components/TermsOfUse';
import Download from './components/Download';
import AppLinkFallback from './components/AppLinkFallback';
import './App.css';
import './firebase';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/request-account-delete" element={<RequestAccountDelete />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/download" element={<Download />} />
          <Route path="/app/*" element={<AppLinkFallback />} />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
